var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8372 13.1195L20 11.75L26.1627 13.1195C26.3293 13.1565 26.4782 13.2492 26.585 13.3823C26.6918 13.5154 26.75 13.6809 26.75 13.8515V21.3417C26.7499 22.0826 26.567 22.8119 26.2174 23.465C25.8678 24.1181 25.3624 24.6749 24.746 25.0858L20 28.25L15.254 25.0858C14.6377 24.6749 14.1323 24.1183 13.7828 23.4653C13.4332 22.8124 13.2502 22.0832 13.25 21.3425V13.8515C13.25 13.6809 13.3082 13.5154 13.415 13.3823C13.5218 13.2492 13.6707 13.1565 13.8372 13.1195ZM14.75 14.453V21.3417C14.75 21.8356 14.8719 22.3218 15.1049 22.7572C15.338 23.1926 15.6749 23.5638 16.0858 23.8378L20 26.4478L23.9142 23.8378C24.325 23.5639 24.6619 23.1928 24.8949 22.7575C25.1279 22.3223 25.2499 21.8362 25.25 21.3425V14.453L20 13.2875L14.75 14.453Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/Icon1_3.ac3e2fabd080225312316c61fb9a7e56.svg";
export { ForwardRef as ReactComponent };